// @core/api/endpoints/affiliate/activate_offer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ActivateOfferRequest,
  OfferResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Activate offer
 * Performs activate operation on offer.
 */
export async function ActivateOffer(
  offer_id: string,
  data: ActivateOfferRequest,
  options?: RequestOptions
): Promise<OfferResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/offers/:offer_id/activate`;
  requestPath = requestPath.replace(':offer_id', encodeURIComponent(offer_id));
  const requestOptions = options;
  return client.post<OfferResponse>(requestPath, data, requestOptions);
}
